import { get } from 'svelte/store';
import { _ } from 'svelte-i18n';
import { detectBrowserLocale } from './i18n';
import { toastStore } from './stores/toastStore';

export const CHUNK_RELOAD_MARKER_KEY = 'plc.chunkReloaded';

const I18N_KEY = 'errors.appUpdateFailed';
// Inline fallback: when the chunk is missing, the locale files may be missing too.
const FALLBACK_TEXT = {
  de: 'Paperless konnte nicht vollständig geladen werden. Bitte lade die Seite neu.',
  en: 'Paperless could not be loaded completely. Please reload the page.',
};

export function updateFailedText(): string {
  try {
    const translated = get(_)(I18N_KEY);
    if (translated && translated !== I18N_KEY) return translated;
  } catch {
    // i18n not initialised yet — use the inline text
  }
  return detectBrowserLocale().startsWith('de') ? FALLBACK_TEXT.de : FALLBACK_TEXT.en;
}

/** Returns true when the marker was newly set (reload allowed), false otherwise. */
function claimReload(): boolean {
  try {
    if (sessionStorage.getItem(CHUNK_RELOAD_MARKER_KEY)) return false;
    sessionStorage.setItem(CHUNK_RELOAD_MARKER_KEY, '1');
    return true;
  } catch {
    return false;
  }
}

export function registerPreloadErrorHandler(): void {
  window.addEventListener('vite:preloadError', () => {
    if (claimReload()) {
      window.location.reload();
    } else {
      toastStore.error(updateFailedText(), 0);
    }
  });
}

export function clearChunkReloadMarker(): void {
  try {
    sessionStorage.removeItem(CHUNK_RELOAD_MARKER_KEY);
  } catch {
    // storage unavailable — nothing to clear
  }
}
